import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TestimonialCard from 'components/common/TestimonialCard';
import PrevIcon from './components/PrevIcon';
import NextIcon from './components/NextIcon';
import { TransitionGroup, CSSTransition } from 'react-transition-group';

import './styles/testimonial.scss';
import './styles/testimonial-animate.scss';

export default class Testimonial extends Component {

  cardRefs = {};

  getCardRef(key) {
    if (!this.cardRefs[key]) {
      this.cardRefs[key] = React.createRef();
    }
    return this.cardRefs[key];
  }

  constructor(props) {
    super(props);
    this.state = {
      shownTestimonial: {},
      slide: 0,
      maxSlide: 0,
      prevHover: false,
      nextHover: false,
      prevAnimate: false,
      nextAnimate: false,
      buttonsActive: true
    };
  }

  handleSlideChange(slide, testimonials, init) {
    // passing testimonials in because this.props may not be updated on props change
    let setShownTestimonial = testimonials[slide];
    if (this.state.buttonsActive || init) {
      this.enableButtons();
      this.setState({
        slide: slide,
        shownTestimonial: setShownTestimonial.fields,
        buttonsActive: false
      });
    }
  }

  init(props) {
    if (props.testimonials.length > 0) {
      const setMaxSlide = props.testimonials.length - 1;
      this.setState({ shownTestimonial: {}, slide: 0, maxSlide: setMaxSlide });
      this.handleSlideChange(0, props.testimonials, true);
    }
  }

  componentDidMount() {
    this.init(this.props);
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    this.init(newProps);
  }

  nextSlide() {
    const { slide, maxSlide } = this.state;
    if (slide < maxSlide) {
      const nextSlide = slide + 1;
      this.handleSlideChange(nextSlide, this.props.testimonials);
    } else if (slide === maxSlide) {
      const nextSlide = 0;
      this.handleSlideChange(nextSlide, this.props.testimonials);
    }
  }

  prevSlide() {
    const { slide, maxSlide } = this.state;
    if (slide > 0) {
      const prevSlide = slide - 1;
      this.handleSlideChange(prevSlide, this.props.testimonials);
    } else if (slide === 0) {
      const nextSlide = maxSlide;
      this.handleSlideChange(nextSlide, this.props.testimonials);
    }
  }

  enableButtons() {
    setTimeout(() => {
      this.setState({ buttonsActive: true });
    }, 1000);
  }

  render() {
    const { slide, maxSlide, shownTestimonial } = this.state;
    return (
      <div className="testimonial-section">
        <div className="testimonial-section__content">
          <button
            className={maxSlide === 0 ? 'testimonial-section__content__scroll-btn-inactive' : 'testimonial-section__content__scroll-btn'}
            onMouseOver={() => this.setState({ prevHover: true })}
            onMouseOut={() => this.setState({ prevHover: false })}
            onClick={() => { this.prevSlide(); this.setState({ prevAnimate: true }) }}>
            <PrevIcon active={this.state.prevHover} />
          </button>
          <TransitionGroup style={{ width: '100%' }}>
            <CSSTransition key={slide}
              nodeRef={this.getCardRef(slide)}
              classNames={`testimonial-animate-${(this.state.prevAnimate ? 'left' : 'right')}`}
              timeout={1000}>
              <div ref={this.getCardRef(slide)} className="testimonial-section__content__testimonial-card">
                <TestimonialCard info={shownTestimonial} />
              </div>
            </CSSTransition>
          </TransitionGroup>
          <button
            className={maxSlide === 0 ? 'testimonial-section__content__scroll-btn-inactive' : 'testimonial-section__content__scroll-btn'}
            onMouseOver={() => this.setState({ nextHover: true })}
            onMouseOut={() => this.setState({ nextHover: false })}
            onClick={() => { this.nextSlide(); this.setState({ prevAnimate: false }) }}>
            <NextIcon active={this.state.nextHover} />
          </button>
        </div>
        <div className="testimonial-section__responsive-btns">
          <button
            className={slide === 0 ? 'testimonial-section__content__scroll-btn-inactive' : 'testimonial-section__content__scroll-btn'}
            onMouseOver={() => { if (slide !== 0) this.setState({ prevHover: true }); }}
            onMouseOut={() => this.setState({ prevHover: false })}
            onClick={() => this.prevSlide()}>
            <PrevIcon active={this.state.prevHover} />
          </button>
          <button
            className={slide === maxSlide ? 'testimonial-section__content__scroll-btn-inactive' : 'testimonial-section__content__scroll-btn'}
            onMouseOver={() => { if (slide !== maxSlide) this.setState({ nextHover: true }); }}
            onMouseOut={() => this.setState({ nextHover: false })}
            onClick={() => this.nextSlide()}>
            <NextIcon active={this.state.nextHover} />
          </button>
        </div>
      </div>
    );
  }
}

Testimonial.propTypes = {
  testimonials: PropTypes.array
};
